module.exports = __webpack_public_path__ + "img/company-white.webp";